import moment from "moment";
import {
  CopilotResponseActionType,
  MikeMessageParameters,
  Request,
  Requests,
  ResponseViewModel,
  Response,
} from "../types/copilot";

export const mapMikeMessageParameters = (response: Response) => {
  return response?.data || response?.parameters
    ? (JSON.parse(
        response.data || response.parameters || "{}",
      ) as MikeMessageParameters)
    : {};
};

export const mapRequestToRequestResponseViewModel = (
  requests: Requests[],
  sort?: boolean,
):
  | {
      requests: Request[];
      responses: ResponseViewModel[];
    }
  | undefined => {
  return {
    requests: requests
      .map<Request>((t) => t.request)
      .filter(
        (item, index, list) =>
          list.findIndex((l) => l.id === item.id) === index,
      ),
    responses: requests
      .flatMap((t) =>
        t.responses.map<ResponseViewModel>((r) => ({
          ...r,
          requestId: t.request.id,
          params: mapMikeMessageParameters(r),
        })),
      )
      .filter(
        (item, index, list) =>
          list.findIndex((l) => l.id === item.id) === index,
      )

      .sort((a, b) => sortRequests(a, b, sort)),
  };
};

export const sortRequests = (
  a: ResponseViewModel,
  b: ResponseViewModel,
  sortByDate?: boolean,
) => {
  if (sortByDate) {
    const dateComparison = moment(a.operationDate).diff(
      moment(b.operationDate),
    );

    if (dateComparison !== 0) {
      return dateComparison;
    }

    return sortByLaserScanRule(a, b);
  } else {
    return sortByLaserScanRule(a, b);
  }
};

/*INFO: Fatih,
 HealthProcessSummary should come after laserscan
 Data coming from the socket should not be sorted by date
  */
export const sortByLaserScanRule = (
  a: ResponseViewModel,
  b: ResponseViewModel,
) => {
  return a.operationDate === b.operationDate &&
    a.actionType === CopilotResponseActionType.HealtProcessSummary &&
    b.actionType === CopilotResponseActionType.LaserScan
    ? 1
    : a.operationDate === b.operationDate &&
        a.actionType === CopilotResponseActionType.LaserScan &&
        b.actionType === CopilotResponseActionType.HealtProcessSummary
      ? -1
      : 0;
};
